import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'Algemeen',
    [Tab.SignedLive]: 'Ondertekend / Live',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Commissie',
  },
};
